import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import { PersonalInfoSettings } from '../components/auth/PersonalInfoSettings';
import { TwoFactorSettings } from '../components/auth/TwoFactorSettings';
import { CreditBalancePanel } from '../components/auth/CreditBalancePanel';
// import { SessionManagement } from '../components/auth/SessionManagement';

export const AccountSettingsPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Account Settings
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Manage your profile and security settings
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <PersonalInfoSettings />
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <TwoFactorSettings />
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Renders nothing when the customer has no credit arrangement or the request is refused,
            so the section is invisible for shoppers who never buy on credit. */}
        <Box sx={{ mb: 4 }}>
          <CreditBalancePanel />
        </Box>

        {/* Temporarily hidden - session management needs fixes */}
        {/* <Divider sx={{ my: 3 }} />

        <Box>
          <SessionManagement />
        </Box> */}
      </Paper>
    </Container>
  );
};
